<template>
  <div>
      <div class="header">
        <div class="cell x-small">
          <span v-text="$t('date')"></span>
        </div>
        <div class="cell small">
          <span v-text="$t('dish_type')"></span>
        </div>
        <div class="cell">
          <span v-text="$t('flexible_rule')"></span>
        </div>
      </div>
      <div class="content">
        <div
          v-for="(row, index) in processedFlexRules"
          :key="index"
          class="row"
        >
          <div class="cell x-small center">{{ row.date }}</div>
          <div class="cell small center">{{ row.dish }}</div>
          <div class="cell center">{{ row.rule }}</div>
        </div>
      </div>
    </div>
</template>


<script>
export default {
  name: "FlexibleRulesComponent",
  props: ["cardData"],
  computed: {
    processedFlexRules() {
      const catalog = this.cardData?.dataCatalog;

      if (
        !catalog ||
        !Array.isArray(catalog.ignoredRules)
      ) {
        return [];
      }

      const result = [];
      const seen = new Set();

      for (const r of catalog.ignoredRules) {
        const date = r.data;
        const dish = catalog?.colunas?.[r?.id_coluna]?.nm_tipoprato;

        if (!dish) continue;

        const rule = this.$t(r.rule);

        const key = `${date}_${dish}_${rule}`;
        if (seen.has(key)) continue;
        seen.add(key);

        result.push({ date, dish, rule });
      }

      return result;
    }
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.header {
  display: flex;
  background-color: @azul;
  color: white;
  padding: 5px;
  border-radius: 5px 5px 5px 5px;
  @size: calc((100% - 25%) / 5);
  grid-template-columns: 25% @size @size @size @size @size;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.content {
  display: flex;
  flex-direction: column;
  max-height: 20em; 
  overflow-y: auto;
}

.row {
  display: flex;
  justify-content: space-around;
  padding: 0.5px;
}
.row:nth-child(even) {
  background-color: #fff; 
}

.row:nth-child(odd) {
  background-color: #f0f0f0; 
}

.cell {
  flex: 1;
  display: flex;; 
}

.small {
  flex: 0.4;
}

.x-small {
  flex: 0.15; 
}

.center {
  width: 100%;
  position: relative;
  display: block;
  max-height: calc(100vh - 100px);
  overflow: auto;
  padding-bottom: 10px;
  font-size: 15px;
  padding: 5px 0;

}
</style>